import icononedeaddiction from 'src/assets/icononedeaddiction.png';
import icontwodeaddiction from 'src/assets/icontwodeaddiction.png';
import iconthreeaddiction from 'src/assets/iconthreeaddiction.png';
import iconfourdeaddiction from 'src/assets/iconfourdeaddiction.png';
import deaddiction5 from 'src/assets/deaddiction5.png';
import deaddiction6 from 'src/assets/deaddiction6.png';
import deaddiction7 from 'src/assets/deaddiction7.png';
import deaddiction8 from 'src/assets/deaddiction8.png';

import { ButtonBase } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { SOMYA_ADDICTION_EVENT_URL } from '../../BehavioralAddictionPlan'
import TDCTypeOne from '../common/TopicDetailComponents/TDCTypeOne'
import { TDCTOSecondaryItemContainer } from '../common/TopicDetailComponents/TDCTypeOneStyles'
import { ProvedTechniquesListContainer, ProvenTechniquesImage } from './EvidenceBasedPlanStyles'

export default function EvidenceBasedPlans({ buttonsOnClick }) {
  const imageStyle = { width: '40px', height: '40px', objectFit: 'cover' }

  return (
    <>
      <TDCTypeOne
        heading={'Evidence-Based De-Addiction Plans'}
        headingColor={'#fff'}
        backgroundColor={'#1c2120'}
        buttonsOnClick={buttonsOnClick}
        primaryData={[
          {
            heading: 'Tailored for Your Success',
            headingColor: '#cad2fe',
            description:
              'At AUMHUM, we have meticulously designed our addiction recovery plans by integrating proven techniques validated through extensive research. Our approach ensures you receive the most effective support tailored to your unique needs, making our plan the only solution you need to achieve lasting freedom from addiction.',
            descriptionColor: '#fff',
          },
          {
            heading: 'PROVEN TECHNIQUES',
            headingColor: '#cad2fe',
            descriptionComponent: <ProvenTechniquesList />,
          },
          {
            heading: 'PERSONALIZED FOR YOU',
            headingColor: '#cad2fe',
            description:
              'What sets our program apart is our commitment to personalization. Our experts work closely with you to tailor every aspect of the recovery plan to your specific needs, preferences, and circumstances. This personalized approach ensures you receive the most relevant and effective support.',
            descriptionColor: '#fff',
          },
        ]}
        secondaryData={[
          {
            icon: <img src={icononedeaddiction} style={imageStyle} alt='overcameIcon' />,
            primaryText: '85%',
            secondaryText: 'OVERCAME CRAVINGS',
          },
          {
            icon: <img src={icontwodeaddiction} style={imageStyle} alt='sobrietyIcon' />,
            primaryText: '78%',
            secondaryText: 'MAINTAINED LONG-TERM SOBRIETY',
          },
          {
            icon: <img src={iconthreeaddiction} style={imageStyle} alt='wellbeingIcon'/>,
            primaryText: '82%',
            secondaryText: 'IMPROVED MENTAL WELL-BEING',
          },
          {
            icon: <img src={iconfourdeaddiction} style={imageStyle} alt='relationshipIcon' />,
            primaryText: '70%',
            secondaryText: 'REBUILT HEALTHY RELATIONSHIPS',
          },
        ]}
        SecondaryDataComponent={TDCTOSecondaryComponent}
        SecondarySideActionButtonComponent={ReadyToStartYourJourney}
      />
    </>
  )
}

const TDCTOSecondaryComponent = ({ icon, primaryText, secondaryText, index }) => {
  return (
    <TDCTOSecondaryItemContainer altColor={index % 2 === 0}>
      {icon && <div>{icon}</div>}
      {primaryText && <div className="primary-text">{primaryText}</div>}
      {secondaryText && <div className="secondary-text">{secondaryText}</div>}
    </TDCTOSecondaryItemContainer>
  )
}

const ReadyToStartYourJourney = ({ buttonsOnClick }) => {
  const navigate = useNavigate()
  return (
    <ButtonBase
      sx={{
        padding: '13px 13px',
        background: '#705DBB',
        color: '#fff',
        borderRadius: '18px',
        letterSpacing: '2px',
      }}
      onClick={() => (buttonsOnClick ? buttonsOnClick() : navigate(SOMYA_ADDICTION_EVENT_URL))}
    >
      READY TO START YOUR JOURNEY?
    </ButtonBase>
  )
}

const ProvenTechniquesList = () => {
  return (
    <>
      <ListComponent
        imageComponent={<ProvenTechniquesImage src={deaddiction5} alt='CBT_Icon' />}
        primaryText={'Cognitive Behavioral Therapy (CBT)'}
        secondaryText={'- Helps identify and change negative thought patterns.'}
      />
      <ListComponent
        imageComponent={<ProvenTechniquesImage src={deaddiction6} alt='MI_Icon' />}
        primaryText={'Motivational Interviewing (MI)'}
        secondaryText={'- Enhances commitment to change.'}
      />
      <ListComponent
        imageComponent={<ProvenTechniquesImage src={deaddiction7} alt='MAT_Icon'/>}
        primaryText={'Medication-Assisted Treatment (MAT)'}
        secondaryText={' - Manages withdrawal symptoms and cravings.'}
      />
      <ListComponent
        imageComponent={<ProvenTechniquesImage src={deaddiction8} alt='MBRP_Icon' />}
        primaryText={'Mindfulness-Based Relapse Prevention (MBRP)'}
        secondaryText={'- Increases awareness and emotional regulation.'}
      />
    </>
  )
}

const ListComponent = ({ primaryText, secondaryText, imageComponent }) => {
  return (
    <ProvedTechniquesListContainer>
      {imageComponent}
      <div>
        <h6 className="primary-text">{primaryText}</h6>
        <div className="secondary-text">{secondaryText}</div>
      </div>
    </ProvedTechniquesListContainer>
  )
}
